import React, { useState, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button, Input, Tooltip, Modal } from "antd";
import { CheckCircleFilled, CloseCircleTwoTone, TagOutlined } from "@ant-design/icons";
import { coupons_post } from "api/coupons";
import CustomButton from "Components/CustomButton";

// const dbCouponsPost = (code, body) => {
//   return new Promise((resolve) => {
//     try {
//       coupons_post(code, body)
//         .then((res) => resolve({ status: true, data: res.data }))
//         .catch((err) => {
//           resolve({ status: false, data: err });
//         });
//     } catch (error) {
//       resolve({ status: false, data: error });
//     }
//   });
// };

// const validateCoupon = async (couponCode, data, actionHandler, setIsLoading) => {
//   setIsLoading(true);

//   const couponResponse = await dbCouponsPost(couponCode, {
//     identification: data.identification,
//     main_product: data.main_product,
//     price_options: data.price_options,
//     purchase_id: data.purchase_id,
//     purchase_products: data.purchase_products,
//   });
//   if (!couponResponse.status) {
//     notification.warning({
//       message: "Não foi possível validar o cupão",
//       description: "Ocorreu um erro ao validar o cupão. Tenta novamente mais tarde.",
//     });
//     setIsLoading(false);
//     return;
//   }

//   const couponData = couponResponse.data;

//   if (!couponData.status) {
//     notification.warning({
//       message: "Oops!",
//       description: couponData.message,
//     });
//     setIsLoading(false);
//     return;
//   }

//   actionHandler("coupon", couponData.data);
//   setIsLoading(false);
// };

const submitCoupon = async (couponCode, data, actionHandler, setIsLoading, t, customStyle) => {
  if (!couponCode || couponCode === "") {
    const primary = customStyle?.primary;
    const okButtonProps = primary?.backgroundColor
      ? {
          style: {
            backgroundColor: primary.backgroundColor,
            borderColor: primary.borderColor || primary.backgroundColor,
            color: primary.color || "#fff",
          },
        }
      : undefined;
    Modal.warning({
      title: t("coupon.missingCodeTitle"),
      content: t("coupon.missingCodeDescription"),
      okButtonProps,
    });
    return;
  }

  // validateCoupon(couponCode, data, actionHandler, setIsLoading);

  actionHandler("coupon", couponCode);
};

const InsertCoupon = ({ data, actionHandler, couponCode, isBusy, isLoading, setCouponCode, setIsLoading, customStyle }) => {
  const { t } = useTranslation();
  const validCoupon = data?.coupon?.coupon_code && data?.coupon?.active === true;
  if (validCoupon) couponCode = data?.coupon?.coupon_code;

  return (
    <>
      <div className="coupon-insert-row" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <Input
          className={`form-item-coupon ${validCoupon ? "coupon-active" : ""}`}
          value={couponCode}
          readOnly={validCoupon}
          disabled={isBusy}
          placeholder={t("coupon.placeholder")}
          onChange={(e) => setCouponCode(e.target.value)}
          suffix={
            validCoupon ? (
              <Tooltip title={t("coupon.appliedTooltip")}>
                <CheckCircleFilled style={{ color: "#52c41a" }} />
              </Tooltip>
            ) : undefined
          }
        />
        {validCoupon ? (
          <Button
            className="coupon-button-remove"
            danger
            onClick={(e) => {
              e.preventDefault();
              actionHandler("remove-coupon", null);
              setCouponCode("");
            }}
          >
            <CloseCircleTwoTone twoToneColor={"#f5222d"} /> {t("coupon.removeButton")}
          </Button>
        ) : (
          <CustomButton
            addClass="coupon-button"
            htmlType="button"
            loading={isLoading}
            disabled={isBusy || validCoupon}
            onClick={() => submitCoupon(couponCode, data, actionHandler, setIsLoading, t, customStyle)}
            type="outline"
            buttonStyle={customStyle}
          >
            {t("coupon.applyButton")}
          </CustomButton>
        )}
      </div>
    </>
  );
};

const isBusy = (isLoading, disabled) => {
  if (isLoading === true) return true;
  if (disabled === true) return true;
  return false;
};
const Coupon = ({ show = false, disabled, data, actionHandler, customStyle }) => {
  const { t } = useTranslation();
  const [couponCode, setCouponCode] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (data?.coupon?.isLoading === true) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (data?.coupon?.coupon_code !== null && data !== "") {
      setCouponCode(data?.coupon?.coupon_code);
    }

    if (data?.coupon?.coupon_code === "") {
      setCouponCode("");
    }
  }, [data, isLoading, disabled]);

  if (!data) return <></>;

  const statusAction = data?.status?.action;
  const isDisabled = statusAction === "paid" || statusAction === "wait-for-payment";
  if (isDisabled && !couponCode) return <></>;
  if (isDisabled && couponCode)
    return (
      <div>
        <Trans
          i18nKey="coupon.couponCodeDisplay"
          values={{ code: couponCode }}
          components={{ strong: <strong /> }}
        />
      </div>
    );
  if (show)
    return (
      <InsertCoupon
        data={data}
        actionHandler={actionHandler}
        couponCode={couponCode}
        isBusy={isBusy(isLoading, disabled)}
        isLoading={isLoading}
        setCouponCode={setCouponCode}
        setIsLoading={setIsLoading}
        customStyle={customStyle}
      />
    );

  if (!show) {
    const linkColor = customStyle?.link?.linkColor;
    const couponActive = data?.coupon?.active === true;

    // Applied coupon, or user opened the field → show input + button directly.
    if (couponActive || open) {
      return (
        <div className="coupon-reveal">
          <InsertCoupon
            data={data}
            actionHandler={actionHandler}
            couponCode={couponCode}
            isBusy={isBusy(isLoading, disabled)}
            isLoading={isLoading}
            setCouponCode={setCouponCode}
            setIsLoading={setIsLoading}
            customStyle={customStyle}
          />
        </div>
      );
    }

    // Collapsed state: a simple modern trigger that reveals the field on click.
    return (
      <button type="button" className="coupon-toggle" style={{ color: linkColor }} onClick={() => setOpen(true)}>
        <TagOutlined />
        {t("coupon.collapseHeader")}
      </button>
    );
  }
};

export default Coupon;
